// 跨年红包ID数组
export const MAMMON_ARRAY = [41, 42, 43, 44, 45]
